
  import classNames from 'classnames'
  import type { ShapeComponentType } from '../types'

  export const Shadow02:ShapeComponentType = ({ className, ...props }) => {
    return <svg className={classNames('pintxo-shape', className)} {...props} width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.208831 99.928C2.79748 89.8399 40.9328 95.6736 70.4497 91.4192C106.565 86.1978 128 87.5837 128 91.3869C128.063 103.344 98.2935 103.763 71.6178 117.139C50.9086 127.517 -3.79707 106.838 0.208831 99.928Z" fill="#0C0D0D"/>
</svg>

  }
  
